import DataStudio from "./DataStudio.jsx"

export default DataStudio;